export default "__VITE_ASSET__DvF1C3IF__"